import { NumberValue, VALUE_TYPE } from "Components/NumberValue";

import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { CabinContentsProduct } from "Store/interfaces/products/checkout/riskProducts/houseProducts/CabinContentsProduct";
import { isDefined } from "Utils/functions";
import React from "react";

export const cabinContentsDetailsList = (
  product: CabinContentsProduct,
): ProductDetail[] => {
  return [
    {
      name: "deductible",
      value: (
        <DeductibleValue
          value={product.priceSpecifications.deductible.code ?? "??"}
        />
      ),
    },
    {
      name: "contentsInsuranceSum",
      value: (
        <NumberValue
          value={product.coverageAmountCabinContent ?? 0}
          type={VALUE_TYPE.NOK}
        />
      ),
      hidden: product.coverageAmountCabinContent === 0,
    },
    {
      name: "hasElectricity",
      value: <YesOrNo value={product?.hasElectricity ?? false} />,
    },
    {
      name: "hasTapWater",
      value: <YesOrNo value={product?.hasTapWater ?? false} />,
    },
    {
      name: "hasRental",
      value: <YesOrNo value={product.hasRental ?? false} />,
      hidden: !isDefined(product.hasRental),
    },
    { name: "injuries", value: product.damageCountRecentYears ?? 0 },
    {
      name: "injuryYear",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
  ];
};
